import { render, staticRenderFns } from "./prop.vue?vue&type=template&id=630f2673&scoped=true"
import script from "./prop.vue?vue&type=script&lang=js"
export * from "./prop.vue?vue&type=script&lang=js"
import style0 from "./prop.vue?vue&type=style&index=0&id=630f2673&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630f2673",
  null
  
)

export default component.exports